module.exports = __webpack_public_path__ + "static/media/anu.a648371f.png";